import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';
import { loading as commonLoading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { IDistributionGroup } from 'pages/Timesheet/TimesheetEngNetworks/types';

interface IDistributionStore {
  list: IDistributionGroup[];
  loading: boolean;
  count: number;
}

const initialState: IDistributionStore = {
  list: [],
  loading: false,
  count: 0,
};

const reset: CaseReducer<IDistributionStore> = () => initialState;

const loading: IReducer<IDistributionStore, boolean> = commonLoading;

const count: CaseReducer<IDistributionStore, PayloadAction<number>> = (state, action) => {
  state.count = action.payload;
};

const list: CaseReducer<IDistributionStore, PayloadAction<IDistributionGroup[]>> = (
  state,
  action,
) => {
  state.list = action.payload;
};

export const distributionSlice = createSlice({
  name: 'distribution',
  initialState,
  reducers: {
    reset,
    loading,
    count,
    list,
  },
});

const {
  reset: setDistReset,
  loading: setDistLoading,
  list: setDistribution,
  count: setCount,
} = distributionSlice.actions;

const fetchDistribution =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setDistLoading(true));
    // TODO
    get<unknown>('/api/timesheet/engineering_appointment/', params)
      /* TODO any */
      .then(({ data }) => {
        const results = data;
        // @ts-ignore TODO TS err
        dispatch(setDistribution(results?.groups));
        // @ts-ignore TODO TS err
        dispatch(setCount(results?.total));
      })
      .finally(() => dispatch(setDistLoading(false)));
  };

export const getDistribution =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(fetchDistribution(params));
  };

export { setDistReset, setDistribution, setCount };
